import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import awsconfig from 'aws-exports';

if (import.meta.env.VITE_AUTH_DOMAIN !== '') {
    const oauth = {
        domain: `${import.meta.env.VITE_AUTH_DOMAIN}`,
        scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${window.location.origin}/`,
        redirectSignOut: `${window.location.origin}/`,
        responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        identityProvider: import.meta.env.VITE_IDP,
        client_id: awsconfig.aws_user_pools_web_client_id,
    };
    awsconfig.oauth = oauth;
}
Amplify.configure(awsconfig);

const url = awsconfig.aws_appsync_graphqlEndpoint;
const region = awsconfig.aws_appsync_region;

const auth = {
    type: awsconfig.aws_appsync_authenticationType as AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await fetchAuthSession()).tokens?.idToken?.toString() || '',
};

const httpLink = new HttpLink({ uri: url });

const link = ApolloLink.from([createAuthLink({ url, region, auth }), httpLink]);

export const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
});
